<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色在应用中数据及操作项的权限；</span
        >如果需要进行二次授权时，可选择的权限范围为此处配置的资源及操作项权限。
      </div>
    </div>
    <div style="width:100%">
      <div class="flex_spaceBetween">
        <span></span>
        <div class="flex_end">
          <span class="font_13_color_666666" style="margin-right:10px">可读</span>
          <span class="font_13_color_666666">可删除</span>
        </div>
      </div>
      <div class="flex_spaceBetween" v-for="(item, index) in eventTypeArray" :key="index">
        <span>{{ item.eleName }}</span>
        <div class="flex_end">
          <el-checkbox disabled v-model="item.isCanRead" @change="changedMenthod"></el-checkbox>
          <el-checkbox
            disabled
            v-model="item.isCanDelete"
            style="margin-right:10px"
            @change="changedMenthod"
          >
          </el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from '@/lib/axios';
import API from '@/lib/apiList';

export default {
  data() {
    return {
      eventTypeArray: [] //事件类型字典数组
    };
  },
  mounted() {
    this.getEventTypeDictionaryRequest();
  },
  methods: {
    changedMenthod() {
      let dict = {
        value: this.eventTypeArray
      };
      this.$emit('applicationAuthorAlarmTwoMenthod', dict);
    },

    /** 获取告警事件类型字典项数据 */
    getEventTypeDictionaryRequest() {
      const that = this;
      Axios.requestWWWForm({
        url: '/unicom/element/searchPage',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          eleGroupId: 'EVENT_TYPE'
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            let array = res.data.result;
            this.eventTypeArray = array;
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}

.flex_spaceBetween {
  width: 50%;
  padding-left: 30px;
  display: flex;
  height: 30px;
  justify-content: space-between;
  align-items: center;
}

.flex_end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.font_13_color_666666 {
  font-size: 13px;
  color: #666666;
}
</style>
